import { TAILWIND_COLOR_HEX } from "./tailwindColors";

const API_BASE_URL = "/api3004";

export function getAuthHeader() {
    const token = localStorage.getItem("token");
    return { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
}

export function getAuthHeaderOnly() {
    const token = localStorage.getItem("token");
    return { Authorization: `Bearer ${token}` };
}

export const ANNOUNCEMENT_TARGET_OPTIONS = [
    { value: 1, label: "Kobe-Ya" },
    { value: 2, label: "consignment-app" },
    { value: 3, label: "supplier-web" },
];

/** @deprecated ANNOUNCEMENT_TARGET_OPTIONS を使用 */
export const TARGET_OPTIONS = ANNOUNCEMENT_TARGET_OPTIONS;

export function targetLabel(value) {
    const opt = ANNOUNCEMENT_TARGET_OPTIONS.find((o) => o.value === Number(value));
    return opt ? opt.label : String(value);
}

/** 公開先ラベル配列（最大3行表示用） */
export function formatAnnouncementTargetLabels(targets, maxLines = 3) {
    const labels = (Array.isArray(targets) ? targets : [])
        .map((t) => targetLabel(t))
        .slice(0, maxLines);
    return labels;
}

export function truncateContent(text, maxLen = 120) {
    if (!text) return "";
    const s = String(text);
    return s.length <= maxLen ? s : `${s.slice(0, maxLen)}...`;
}

/** 公開日時を YYYY/MM/DD 形式で表示 */
export function formatPublishedDate(value) {
    if (!value) return "—";
    const dt = new Date(value);
    if (isNaN(dt.getTime())) return "—";
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const d = String(dt.getDate()).padStart(2, "0");
    return `${y}/${m}/${d}`;
}


export const DEFAULT_CATEGORY_COLOR = "text-gray-500";

const TAILWIND_COLOR_NAMES = [
    "slate", "gray", "zinc", "red", "orange", "amber", "yellow", "lime", "green", "emerald",
    "teal", "cyan", "sky", "blue", "indigo", "violet", "purple", "fuchsia", "pink", "rose",
];

/** カテゴリ色を text-{name}-500 形式に正規化 */
export function normalizeCategoryColor(value) {
    if (typeof value !== "string") {
        return DEFAULT_CATEGORY_COLOR;
    }
    const trimmed = value.trim();
    const match = trimmed.match(/^text-([a-z]+)-500$/);
    if (!match || !TAILWIND_COLOR_NAMES.includes(match[1])) {
        return DEFAULT_CATEGORY_COLOR;
    }
    return trimmed;
}

/** カテゴリ色のスウォッチ用インラインスタイル */
export function getCategorySwatchStyle(colorClass) {
    const normalized = normalizeCategoryColor(colorClass);
    const token = normalized.replace(/^text-/, "");
    return { backgroundColor: TAILWIND_COLOR_HEX[token] || TAILWIND_COLOR_HEX["gray-500"] };
}

/** カテゴリタグ表示用スタイル */
export function getCategoryStyle(color) {
    const normalized = normalizeCategoryColor(color);
    const token = normalized.replace(/^text-/, "");
    const hex = TAILWIND_COLOR_HEX[token] || TAILWIND_COLOR_HEX["gray-500"];
    return {
        dotStyle: { backgroundColor: hex },
        textStyle: { color: hex },
    };
}

export async function fetchAnnouncementCategories() {
    const res = await fetch(`${API_BASE_URL}/get_m_announcement_category_list`, {
        headers: getAuthHeaderOnly(),
    });
    if (!res.ok) throw new Error("Failed to fetch categories");
    const json = await res.json();
    return json.data ?? [];
}

export function isMobileViewport() {
    return typeof window !== "undefined" && window.innerWidth < 768;
}

export function isPreviewableFileName(fileName) {
    const ext = String(fileName || "").split(".").pop()?.toLowerCase() || "";
    return ["pdf", "png", "jpg", "jpeg", "webp", "gif"].includes(ext);
}

export function isImageFileName(fileName) {
    const ext = String(fileName || "").split(".").pop()?.toLowerCase() || "";
    return ["png", "jpg", "jpeg", "webp", "gif"].includes(ext);
}

export async function fetchAnnouncementAttachment(announcementId, fileId) {
    const res = await fetch(
        `${API_BASE_URL}/get_announcement_attachment_s3?announcement_id=${announcementId}&announcement_file_id=${fileId}`,
        { headers: getAuthHeaderOnly() }
    );
    if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error(json.error || "Failed to load attachment");
    }
    const json = await res.json();
    return json.data;
}

export function base64ToBlobUrl(base64, contentType) {
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const blob = new Blob([bytes], { type: contentType });
    return URL.createObjectURL(blob);
}

export function readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export { API_BASE_URL };
